"use strict";
/**
 * Add custom tabs to Product page details/sizing/delivery/care
 *
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Alexandra Miro
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tabSelectors = function () {
    var tabs = Array.from(document.querySelectorAll('.tablinks-cus'));
    if (!tabs)
        return;
    var tabContent = Array.from(document.querySelectorAll('.tabcontent-cus'));
    tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
            var element = e.target;
            var data = element.dataset.elementtoshow;
            tabs.forEach(function (otherTabs) { return otherTabs.classList.remove('active'); });
            tab.classList.add('active');
            tabContent.forEach(function (content) {
                if (content.id === data) {
                    content.classList.add('active');
                }
                else {
                    content.classList.remove('active');
                }
            });
        });
    });
};
exports.default = tabSelectors;
